<template>
<div class="table-container">
  <div class="ruleform">
      <div style="margin-top: 20px" class="table">
        <div></div>
        <div style="display: flex">
          <!-- <importBtn style="margin-right: 15px" title="导入安全警示标志台账" download="importBuilding.xlsx" href="/static/xls/importBuilding.xlsx" url="/apps/build/importRiskBuilding" @refreshTable="getList"></importBtn> -->
          <el-button @click="handleReview()" style="height:28px" size="mini" type="success" v-show="review_status != 2">复核通过</el-button>
          <el-button @click="showForm()" style="height:28px" size="mini" type="primary">新增复核意见</el-button>
        </div>
      </div>
      <el-table
        :data="tableData"
        v-loading="loading"
        style="color:#303133;width: 100%; margin-bottom: 10px"
        :header-cell-style="{padding: '8px 0',color: '#303133',backgroundColor: 'rgb(240,245,251)'}"
        :cell-style="cellStyle"
        border
        stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          prop="handle_status"
          show-overflow-tooltip
          label="状态"
          min-width="120">
          <template slot-scope="{row}">
            <span style="color: #67C23A" v-if="row.handle_status == 1">已处理</span>
            <span style="color: #F56C6C" v-else>待处理</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="module"
          show-overflow-tooltip
          label="模块/单元"
          min-width="120">
          <template slot-scope="{row}">
            {{row.module ? row.module : '-'}}
          </template>
        </el-table-column>
        <el-table-column
          prop="field_name"
          show-overflow-tooltip
          label="字段名"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="remark"
          show-overflow-tooltip
          label="问题描述"
          min-width="120">
        </el-table-column>
         <el-table-column
          prop="image_list"
          label="截图"
          min-width="120">
          <template slot-scope="{row}">
            <span style="margin-left:15px;color:#909399" v-if="!row.image_list">-</span>
            <div style="display:flex" v-else>
              <div style="margin-right: 15px" :key="index" v-for="(item, index) in row.image_list.split(',')">
                <el-image
                  v-if="index < 3"
                  style="width: 50px; height: 50px"
                  :src="item"
                  :preview-src-list="row.image_list.split(',')">
                </el-image>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="file"
          show-overflow-tooltip
          label="附件"
          min-width="120">
          <template slot-scope="{row}">
            <template v-if="row.file">
              <el-link @click="$showFile({ url: row.file })" :underline="false"
                target="_blank" type="primary">预览</el-link>
              <el-link :underline="false" :href="row.file" target="_blank" type="primary">下载</el-link>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="supporting_materials_file"
          show-overflow-tooltip
          label="佐证附件"
          min-width="120">
          <template slot-scope="{row}">
            <template v-if="row.supporting_materials_file">
              <el-link @click="$showFile({ url: row.supporting_materials_file })" :underline="false"
                target="_blank" type="primary">预览</el-link>
              <el-link :underline="false" :href="row.supporting_materials_file" target="_blank" type="primary">下载</el-link>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          show-overflow-tooltip
          label="生成时间"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="deadline_time"
          show-overflow-tooltip
          label="整改到期时间"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="handle_time"
          show-overflow-tooltip
          label="处理时间"
          min-width="120">
          <template slot-scope="{row}">
            {{row.handle_time ? row.handle_time : '-'}}
          </template>
        </el-table-column>
        <el-table-column
          prop="operator"
          show-overflow-tooltip
          label="操作人"
          min-width="120">
        </el-table-column>
        <!-- 6.9 -->
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="text"
              @click="showEditForm(scope.row,'credentials')">编辑</el-button>
            <el-button
              size="small"
              type="text"
              @click="handleDelete(scope.row,'credentials')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="width: 100%">
        <el-col :span="24">
          <div style="float:right;padding:10px">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="10"
              layout="total, prev, pager, next, jumper"
              :total="totalCount">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
  </div>
  <addOrUpdateForm :tableData="tableData" :data_class="data_class" :modules="modules" :tab="tab" @refreshTable="refreshTable" ref="addOrUpdateForm"></addOrUpdateForm>
</div>
</template>

<script>
import {api} from '@/api/api'
import addOrUpdateForm from './addOrUpdateForm'
import {tableMixins} from '@/mixins/qiboMixins'
export default {
  components: {
    addOrUpdateForm
  },
  mixins: [tableMixins],
  data () {
    return {
      data_class: 'Recheck',
      pagination: true,
      review_status:null,
    }
  },
  mounted () {
  },
  methods: {
    initTableData(res){
      this.review_status = res.data.page_info.review_status
    },
    handleReview () {
      this.$confirm('确认复核通过?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(
          api[`handleReviewPass`],
          {company_id: this.$store.state.companyId}
        ).then(response => {
          if (response.data.code === 0) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
          } else {
            this.$message({
              type: 'warning',
              message: '操作失败 ' + response.data.msg
            })
          }
        }).catch(error => {
          console.log(error)
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/recheck/table.vue